if (!customElements.get('tpt-hotspots-2')) {
  class TptHotspots2 extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initHotspotPopup();

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
          const section = event.target.querySelector('tpt-hotspots-2');
          if (section) section.initHotspotPopup();
        });
      }
    }

    initHotspotPopup() {
      const section = this;
      const labels = section.querySelectorAll('.tpt-hotspots_2_label');
      const popups = section.querySelectorAll('.tpt-hotspots_2_popup');

      labels.forEach(label => {
        label.addEventListener('click', (e) => {
          e.stopPropagation();

          const popup = label.querySelector('.tpt-hotspots_2_popup');
          const isActive = popup.classList.contains('active');

          popups.forEach(p => {
            p.classList.remove('active');
            p.removeAttribute('data-position');
          });

          if (!isActive) {
            this.positionPopup(popup, label);
            popup.classList.add('active');
          }
        });
      });

      section.addEventListener('click', () => {
        popups.forEach(p => {
          p.classList.remove('active');
          p.removeAttribute('data-position');
        });
      });
    }

    positionPopup(popup, label) {
      const container = label.closest('.tpt-hotspots_2_content-img');
      if (!container) return;

      const labelRect = label.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      popup.style.display = 'flex';
      popup.style.visibility = 'hidden';
      popup.style.opacity = '0';

      const popupRect = popup.getBoundingClientRect();
      const popupWidth = popupRect.width;
      const popupHeight = popupRect.height;

      popup.style.display = '';
      popup.style.visibility = '';
      popup.style.opacity = '';

      const spaceRight = containerRect.right - labelRect.right;
      const spaceLeft = labelRect.left - containerRect.left;
      const spaceTop = labelRect.top - containerRect.top;
      const spaceBottom = containerRect.bottom - labelRect.bottom;

      const padding = 10;

      let horizontalPosition = 'right';
      if (spaceRight < popupWidth + padding && spaceLeft >= popupWidth + padding) {
        horizontalPosition = 'left';
      }

      let verticalPosition = 'center';
      const halfPopupHeight = popupHeight / 2;
      if (spaceTop < halfPopupHeight) {
        verticalPosition = 'top';
      } else if (spaceBottom < halfPopupHeight) {
        verticalPosition = 'bottom';
      }

      const position = `${horizontalPosition}-${verticalPosition}`;
      popup.setAttribute('data-position', position);
    }
  }

  customElements.define('tpt-hotspots-2', TptHotspots2);
}
